export default {"src":"/_next/static/media/google_play_fr.9776f8ab.svg","height":255,"width":861,"blurWidth":0,"blurHeight":0};